<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12">
          <div class="flex flex-col md:flex-row justify-between items-center">
            <button
              class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto invisible hidden md:block">
              + Create New Category
            </button>
            <h1 class="font-semibold text-2xl lg:text-3xl text-center">
              Create Categories
            </h1>
            <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto hidden md:block"
                    @click="onClickCreateNew">
              + Create New Category
            </button>
          </div>
          <section class="text-center text-sm max-w-3xl mx-auto mt-5">
            Add the categories for your menu to this page. Typical categories include: Entrees, Desserts, Sandwiches, Sides....On the next page you will be able to add individual line items for each category along with pricing per serving. Remember that with BuildaBox.co, each attendee will have a chance to build their order, so always break your menu down into individual servings, even for buffet style catering. You will be able to group the individual orders in the order management section after they are completed by the attendees.
          </section>
          <div class="mt-5 md:hidden">
            <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    @click="onClickCreateNew">
              + Create New Category
            </button>
          </div>
          <section class="mt-5">
            <table class="w-full">
              <thead class="md:border-b border-gray-300">
              <tr class="text-gray-500 text-sm">
                <th class="w-64">
                  <div class="flex items-center">
                    <label
                      class="w-20 inline-flex items-center px-3 py-1 border-2 border-gray-200 md:border-none rounded-lg">
                      <input type="checkbox" class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                             v-model="allSelected">
                      <v-popover class="ml-3" :placement="'bottom-start'">
                        <button class="btn">
                          <img src="@/assets/icons/ic_chevron_down.svg" alt="Order Details Categories Page" />
                        </button>
                        <div slot="popover">
                          <div class="bg-white text-gray-700 py-3" role="menu">
                            <a
                              class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                              role="menuitem" @click="allSelected = true" v-close-popover>
                              Select All
                            </a>
                            <a
                              class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                              role="menuitem" @click="allSelected = false" v-close-popover>
                              Unselect All
                            </a>
                            <a
                              class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                              role="menuitem" @click="onClickRemoveSelectedCategories" v-close-popover>
                              Delete Selected
                            </a>
                          </div>
                        </div>
                      </v-popover>
                    </label>
                    <div class="font-semibold text-xs text-gray-600 text-left hidden md:block">CATEGORY</div>
                  </div>
                </th>
                <th class="hidden md:table-cell font-semibold text-xs text-gray-600 text-left">
                  DESCRIPTION
                </th>
                <th class="w-32 hidden md:table-cell font-medium">
                  <div class="flex items-center">
                    <div class="mr-2 font-semibold text-xs text-gray-600"># OF ITEMS</div>
                    <v-popover placement="bottom-start" trigger="hover">
                      <button type="button" class="btn">
                        <img src="@/assets/icons/ic_info.png" alt="BuildaBox Order Process" />
                      </button>
                      <div slot="popover">
                        <div class="w-64 p-4">
                          Enter the number of items that an attendee may select from a category in their order
                        </div>
                      </div>
                    </v-popover>
                  </div>
                </th>
                <th class="w-24 hidden md:table-cell font-medium"></th>
              </tr>
              </thead>
              <tbody v-if="progressLoading">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5">
                    <Spinner class="mx-auto" orange />
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else-if="categories.length === 0">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5"></div>
                </td>
              </tr>
              </tbody>
              <draggable handle=".draggable-handler" tag="tbody" v-model="categories" v-else @update="onUpdateSort">
                <tr v-for="(category, index) in categories" :key="index">
                  <td class="py-5">
                    <div class="flex items-center">
                      <label class="md:w-20 inline-flex items-center px-3 py-1">
                        <input type="checkbox" class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                               v-model="category.isSelected">
                        <button class="btn ml-3 draggable-handler">
                          <img src="@/assets/icons/ic_drag.svg" alt="Order Details Categories Page" />
                        </button>
                      </label>
                      <div class="font-semibold flex-1">{{ category.name }}</div>
                      <div class="md:hidden">
                        <button class="btn p-3" @click="onClickEditCategory(category)">
                          <img src="@/assets/icons/edit-pencil.svg" alt="BuildaBox Order Details Categories Page" />
                        </button>
                        <button class="btn p-3 ml-2" @click="onClickRemoveCategory(category)">
                          <img src="@/assets/icons/ic_remove.svg" alt="BuildaBox Order Details Categories Page" />
                        </button>
                      </div>
                    </div>
                    <div class="md:hidden font-normal ml-12 mr-5">
                      <div class="mt-2 text-gray-600">{{ category.description }}</div>
                      <div class="mt-5">
                        <span class="text-gray-600">NUMBER OF ITEMS:</span>
                        <span class="ml-4">{{ category.items_quantity }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="py-5 hidden md:table-cell font-normal text-gray-600 text-left">
                    {{ category.description }}
                  </td>
                  <td class="py-5 hidden md:table-cell font-normal text-center">
                    {{ category.items_quantity }}
                  </td>
                  <td class="py-5 hidden md:table-cell">
                    <button class="btn p-3" @click="onClickEditCategory(category)">
                      <img src="@/assets/icons/edit-pencil.svg" alt="BuildaBox Order Details Categories Page" />
                    </button>
                    <button class="btn p-3 ml-2" @click="onClickRemoveCategory(category)">
                      <img src="@/assets/icons/ic_remove.svg" alt="BuildaBox Order Details Categories Page" />
                    </button>
                  </td>
                </tr>
              </draggable>
            </table>
          </section>
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <button
                class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                :disabled="!canProceedToNextStep"
                @click="$emit('nextButtonPressed')"
              >
                <span v-if="!progressSaving">Next</span>
                <Spinner class="mx-auto" v-if="progressSaving" />
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Modal v-if="showModal">
      <div slot="modal-wrapper">
        <div class="flex justify-center p-2">
          <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-3xl">
            <CatererCategoryEditor
              :caterer-id="this.caterer.id"
              :category="selectedCategory"
              @submit="showModal = false; loadCategories()"
              @cancel="showModal = false"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Modal from "@/components/common/Modal"
  import Spinner from "@/components/common/Spinner"
  import draggable from "vuedraggable"
  import Api from "@/api/api_v1.0"
  import CatererCategoryEditor from "@/components/CatererCategoryEditor";

  export default {
    components: { CatererCategoryEditor, Spinner, Modal, draggable },
    data() {
      return {
        categories: [],
        selectedCategory: '',
        showModal: false,
        progressLoading: false,
        progressSaving: false
      }
    },
    computed: {
      caterer() {
        return this.$store.state.catererDetails;
      },
      allSelected: {
        get() {
          if (this.categories.length > 0) {
            return this.categories.findIndex(category => !category.isSelected) === -1
          } else {
            return false
          }
        },
        set(value) {
          this.categories.every(category => {
            category.isSelected = value
            return true
          })
        }
      },
      canProceedToNextStep() {
        return this.categories && this.categories.length > 0
      }
    },
    mounted() {
      this.loadCategories()
    },

    beforeCreate() {
      this.$root.$on("catererTrySubmitStep", () => { this.$emit('nextButtonPressed') });
    },
    beforeDestroy() {
      this.$root.$off("catererTrySubmitStep", () => { this.$emit('nextButtonPressed') });
    },

    methods: {
      loadCategories() {
        this.progressLoading = true
        Api.getCatererCategories(this.caterer.id).then(categories => {
          this.progressLoading = false
          this.categories = categories.data
        }).catch(() => {
          this.progressLoading = false
        })
      },
      onClickCreateNew() {
        const position = this.categories.length + 1
        this.selectedCategory = {
          id: '',
          name: '',
          description: '',
          items_quantity: 1,
          file: '',
          image: '',
          position: position
        }
        this.showModal = true
      },
      onClickEditCategory(category) {
        this.selectedCategory = JSON.parse(JSON.stringify(category))
        this.showModal = true
      },
      onSelectImage(event) {
        this.selectedCategory.file = event.target.files[0]
      },
      onClickRemoveCategory(category) {
        this.$swal({
          title: 'Remove Category',
          text: `Are you sure to remove the category - ${category.name}?`,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true
        }).then((result) => {
          if (result.isConfirmed) {
            category.isSelected = true
            this.removeCategories()
          }
        })
      },
      onClickRemoveSelectedCategories() {
        if (this.categories.findIndex(category => category.isSelected) !== -1) {
          this.$swal({
            title: 'Remove Category',
            text: `Are you sure to remove the selected categories?`,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCancelButton: true
          }).then((result) => {
            if (result.isConfirmed) {
              this.removeCategories()
            }
          })
        }
      },
      onUpdateSort() {
        const ids = this.categories.map(category => category.id)
        Api.sortCatererCategories(this.caterer.id, ids)
      },
      async removeCategories() {
        const ids = this.categories.filter(category => category.isSelected).map(category => category.id)
        this.progressLoading = true
        Api.deleteCatererCategories(this.caterer.id, ids).then(() => {
          this.progressLoading = true
          this.loadCategories()
        }).catch(() => {
          this.progressLoading = false
        })
      }
    }
  }
</script>